import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'

import { mobileCSS } from '@measures/responsive'

import { Timeframe } from '../types'

import highFiveLogo from '@assets/images/high-five-logo.png'

interface TitleCardProps {
  timeframe: Timeframe | ''
  formattedUpdatedDate: string
}

const StyledTitleCard = styled.div`
  ${({
    theme: {
      colors: { white },
    },
  }) => {
    return css`
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: ${white};
      ${mobileCSS(css`
        background-position: 70% 0;
      `)}
    `
  }}
`

const TextContainer = styled.div`
  ${({
    theme: {
      fonts: { goodOT },
    },
  }) => {
    return css`
      width: 225px;
      font-family: ${goodOT};
      margin-top: 10px;
    `
  }}
`

const StyledUpdatedDate = styled.span`
  ${({
    theme: {
      colors: { white },
      fonts: { sourceSansPro },
    },
  }) => {
    return css`
      font-size: 12px;
      font-family: ${sourceSansPro};
      font-style: italic;
      color: ${white};
    `
  }}
`

const TitleCard: FunctionComponent<TitleCardProps> = ({
  timeframe,
  formattedUpdatedDate,
}) => {
  return (
    <StyledTitleCard>
      {
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src={highFiveLogo}
          alt="High five"
          width={212}
          height={127}
          loading="lazy"
        />
      }
      <TextContainer>
        Ce que vous devez savoir {timeframe}{' '}
        <StyledUpdatedDate>
          mis à jour à {formattedUpdatedDate}
        </StyledUpdatedDate>
      </TextContainer>
    </StyledTitleCard>
  )
}

export default TitleCard
